/* eslint-disable @typescript-eslint/no-explicit-any */
import { delay } from 'redux-saga/effects';
import { put, call } from 'redux-saga/effects';
import AT from '../constants/action-types';
import { fetchCbxQueueStatus } from '../api';
import logger from '../utils/logger';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function* processCbxQueueStatusSaga() {
  while (true) {
    yield call(delay, 5000);
    try {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const statusResult = yield call(fetchCbxQueueStatus);
      yield put({ type: AT.FETCH_CBX_QUEUE_STATUS_DONE, ...statusResult });
    } catch (e: any) {
      logger.exception('Error while requesting cbx status data', e);
      break;
    }
  }
}

export default function* cbxQueueStatusSaga() {
  // yield takeLatest(AT.APP_INIT_COMPLETED, processCbxQueueStatusSaga);
}
